__turbopack_context__.v({
  "closeBtn": "styles-module-scss-module__lTi13q__closeBtn",
  "description": "styles-module-scss-module__lTi13q__description",
  "logInBtn": "styles-module-scss-module__lTi13q__logInBtn",
  "popover": "styles-module-scss-module__lTi13q__popover",
  "popoverArrow": "styles-module-scss-module__lTi13q__popoverArrow",
  "popoverContainer": "styles-module-scss-module__lTi13q__popoverContainer",
  "title": "styles-module-scss-module__lTi13q__title",
  "wrapper": "styles-module-scss-module__lTi13q__wrapper",
});
